<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.category')"
    resource="categories"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { filterColumnsHash, columnsHash, formColumnsHash } from '../admin_configs/categories/columns';

@Component
export default class Categories extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      { prop: 'title_cont' },
      { prop: 'parent_id_eq' },
    ].filter(Boolean).map(hash => _.merge(filterColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      { prop: 'id' },
      { prop: 'title' },
      {
        prop: 'parent_id',
        label: this.$t('category.parent'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (!row.parent) {
            return <span>/</span>
          }
          return <bean-link keepNode to={{ name: 'categories.show', params: { id: row.parent_id } }}>{row.parent.title}</bean-link>
        }
      },
      { prop: 'image' },
      { prop: 'position' },
      type === 'show' && { prop: 'created_at' },
      type === 'show' && { prop: 'updated_at' },
    ].filter(Boolean).map(hash => _.merge(columnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data }) {
    return [
      { prop: 'title' },
      {
        prop: 'parent_id',
        label: this.$t('category.parent'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            filterable: true,
            xRemotePreload: async () => {
              const data = await this.$request.get('/categories', { id_not_eq: this.$route.params.id, parent_id_null: true, page: 0 });
              return data.map(({ id, title }) => ({ value: id, label: title }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { id_not_eq: this.$route.params.id, parent_id_null: true, translations_title_cont: keyword, page: 0 };
              const data = await this.$request.get('/categories', params);
              return data.map(({ id, title }) => ({ value: id, label: title }));
            }
          }
        }
      },
      !data.parent_id && {
        prop: 'image',
        renderCell: {
          required: true,
          hint: `${this.$t('suggestSize')}: 375xauto`,
        }
      },
      { prop: 'position' },
    ].filter(Boolean).map(hash => _.merge(formColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'categories.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'categories.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/categories',
    name: 'categories.index',
    component: Categories,
    props: {
      type: 'index',
    }
  },
  {
    path: '/categories/new',
    name: 'categories.new',
    component: Categories,
    props: {
      type: 'new',
    }
  },
  {
    path: '/categories/:id',
    name: 'categories.show',
    component: Categories,
    props: {
      type: 'show',
    }
  },
  {
    path: '/categories/:id/edit',
    name: 'categories.edit',
    component: Categories,
    props: {
      type: 'edit'
    }
  }
]
</script>
